/**
 * Notification Severity & Type Display Utilities
 *
 * Maps notification severity levels to Tailwind classes and
 * notification types to human-readable labels.
 */

import type { NotificationSeverity, NotificationType } from '@/shared/types';

interface SeverityStyles {
  border: string;
  bg: string;
  dot: string;
}

const severityMap: Record<NotificationSeverity, SeverityStyles> = {
  info: {
    border: 'border-l-info',
    bg: 'bg-info-bg',
    dot: 'bg-info'
  },
  success: {
    border: 'border-l-success',
    bg: 'bg-success-bg',
    dot: 'bg-success'
  },
  warning: {
    border: 'border-l-warning',
    bg: 'bg-warning-bg',
    dot: 'bg-warning'
  },
  critical: {
    border: 'border-l-destructive',
    bg: 'bg-destructive-bg',
    dot: 'bg-destructive'
  }
};

const typeLabels: Record<NotificationType, string> = {
  goal_milestone: 'Goals',
  budget_alert: 'Budgets',
  settlement_reminder: 'Settle Up',
  system: 'System',
  reimbursement_request: 'Reimbursement',
  net_worth_share_request: 'Sharing'
};

export function getSeverityStyles(severity: NotificationSeverity): SeverityStyles {
  return severityMap[severity];
}

export function getTypeLabel(type: NotificationType): string {
  return typeLabels[type];
}
